module.exports = __webpack_public_path__ + "img/IEC13748.14d9aeb3.png";